import { ICellRendererParams } from "ag-grid-enterprise";
import React from "react";

import { IgTooltip, IgTypography } from "@intelligems/ig-theme";
import { ShopifyProductId } from "@intelligems/ig-utils";
import { Grid, useTheme } from "@mui/material";
import { useConfiguration } from "@src/api/configurations/use-configuration";
import { useGetOrg } from "@src/api/organizations/get-organization";
import { ProductPickerSelectedProduct } from "@src/store/slices/productPicker/types";

export const ProductListText = (
  params: ICellRendererParams & {
    showToolTipText: boolean;
    data: ProductPickerSelectedProduct;
  }
) => {
  const { data, showToolTipText } = params;
  const org = useGetOrg();
  const id = data?.id ? new ShopifyProductId(data.id).id : "";
  const theme = useTheme();
  const onIdClick = () => {
    if (org.data.org.shopId) {
      window.open(
        `https://admin.shopify.com/store/${org.data.org.shopId.replace(/\.myshopify\.com$/, "")}/products/${id}`,
        "_blank",
        "noopener noreferrer"
      );
    }
  };
  return (
    <Grid container item direction={"column"} wrap={"nowrap"}>
      <Grid item sx={{ height: "18px" }}>
        <IgTypography>{data?.title}</IgTypography>
      </Grid>
      <Grid item onClick={onIdClick}>
        <IgTooltip title={"Go to this product in Shopify"}>
          <IgTypography
            sx={{
              "&:hover": {
                cursor: "pointer",
                textDecoration: "underline",
              },
            }}
            variant={"body2"}
            color={theme.palette.text.secondary}
          >
            {id}
          </IgTypography>
        </IgTooltip>
      </Grid>
    </Grid>
  );
};
